import ModalBindings from '../modal/ModalBindings';
import Validation from '../../../common/assets/js/validation';
import CatalogSearchFilter from '../catalog-search-filter/catalog-search-filter';

export default new class AddOffer {
    constructor() {
        this.addOfferModal = '.js-addOfferPopup';
        this.addOfferForm = '.js-addOfferForm';
        this.addOfferConfirmBtn = '.js-addOfferModalConfirm';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('blur', this.addOfferConfirmBtn, (e) => {
                let $form = $(e.target).closest(this.addOfferForm);
    
                if (Validation.isFormValid($form)) {
                    this.addOfferRequest($form);
                }
            })
            .on('click', this.addOfferConfirmBtn, (e) => {
                let $form = $(e.target).closest(this.addOfferForm);

                if (Validation.isFormValid($form)) {
                    this.addOfferRequest($form);
                }
            });
    }

    clearFields() {
        $(this.addOfferModal).find('input[type!="hidden"], textarea[type!="hidden"]').val('');
    }

    addOfferRequest ($form) {
        
        $(this.addOfferForm).request('FormIt::onSend');
        
        ModalBindings.hideModal();
        Validation.removeErrors($form);
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/add-offer/add-offer.js